export interface ITermsAndConditionsPayload {
    hasAgreedTermsAndConditions: boolean;
}

export const getStateToPayload = (privacyPolicyValue: boolean): ITermsAndConditionsPayload => ({
    hasAgreedTermsAndConditions: privacyPolicyValue,
});
